'use client';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import DropZone from '@/components/DropZone';
import ArrowLeftCircle from '@/components/icons/ArrowLeftCircle';
import form from '@/styles/form.module.css';
import { FileState, IFile } from '@/types';
import { FC, useState } from 'react';
import styles from './page.module.css';
import useNavigate from '@/hooks/useNavigate';

const Import: FC<{
  title: string;
  modelLink: string;
  isImportLoading: boolean;
  onImport: (file: FormData) => void;
}> = ({ title, modelLink, isImportLoading, onImport }) => {
  const navigate = useNavigate();
  const [files, setFiles] = useState<IFile[]>([]);

  function onImportFile() {
    if (files) {
      const file = new FormData();
      file.append('file', files[0].file);
      onImport(file);
    }
  }

  return (
    <div className={`flex-column gap-l ${form.content}`}>
      <Button
        variant="ghost"
        icon={<ArrowLeftCircle />}
        onClick={() => navigate(-1)}
      >
        Retour
      </Button>
      <h3>Importer un fichier</h3>
      <Alert
        type="information"
        title={'Pour importer un fichier'}
        message={
          "Assurez-vous de bien utiliser le modèle du fichier, téléchargeable ci-dessous. Cet import permet seulement de créer de nouveaux éléments. L'import ne fait pas de mise à jour d’éléments existants."
        }
      ></Alert>
      <h5>1. Télécharger le modèle du fichier</h5>
      <form method="get" action={modelLink}>
        <Button type="submit" variant="secondary">
          Télécharger le modèle
        </Button>
      </form>
      <h5>{title}</h5>
      <DropZone
        maxLength={10000000} //10 mo
        accept={['text/csv']}
        files={files}
        setFiles={setFiles}
        subText={
          title.includes('agrément')
            ? 'Format accepté : uniquement .csv\nNombre maximal de lignes: 150'
            : 'Format accepté : uniquement .csv\nNombre maximal de lignes: 100'
        }
        multiple={false}
      />
      <div className={styles['validate-container']}>
        <Button
          disabled={
            !files.length ||
            files[0].state !== FileState.DEFAULT ||
            isImportLoading
          }
          loading={isImportLoading}
          onClick={onImportFile}
        >
          Importer
        </Button>
      </div>
    </div>
  );
};

export default Import;
